import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaFire } from "react-icons/fa6";

function MoodStreak() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { dayStreak } = location.state || {};

  // Приклад змінної achievement (її значення повинно бути збережене в localStorage або глобальному стані)
  const achievement = localStorage.getItem("achievement");

  const handleContinueClick = () => {
    if (achievement !== null) {
      navigate("/achievement");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="flex -m-4 flex-col items-center justify-center flex-1 bg-gradient-to-tr from-emerald-500 via-cyan-500 to-emerald-500 bg-gradient-size animate-gradient-move">
      <div className="flex-1 flex flex-col justify-center">
        <FaFire className="w-32 h-32 mb-4 mx-auto" />
        <p className="text-7xl font-bold mb-8">{dayStreak}</p>
        <p className="text-4xl font-bold">- {t("dayStrike")}</p>
      </div>
      {/* Кнопка "CONTINUE" викликає handleContinueClick */}
      <button
        onClick={handleContinueClick}
        className="text-3xl my-6 font-semibold uppercase"
      >
        {t("continue")}
      </button>
    </div>
  );
}

export default MoodStreak;
